// Third-party
import React from 'react';

// Types
import User from '@/types/user';

// Components
import { CloseButton } from '../buttons';
import ComparisonActionCards from '../misc/ComparisonActionCards';
import Modal from '@/views/components/modals/AccessibleModal';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { ALLOWED_HTML_TAGS } from '../i18n/FormattedMessageV2';
import { MODAL_SIZES } from '@/utils/constants';
import { FormattedMessage } from '@/utils/i18n';
import { userHasPermissionEnabled, PERMISSIONS } from '@/utils/permissions';

type Props = {
  show: boolean;
  user: User;
  onClose: () => void;
  onClickPortfolio: () => void;
  onClickClient: () => void;
  onClickModel: () => void;
  onClickFactsetPortfolios: () => void;
};

const CreateAnalysisModal = ({ show, user, onClose, onClickPortfolio, onClickClient, onClickModel, onClickFactsetPortfolios }: Props) => {
  const hasNewPortfolioPermission = userHasPermissionEnabled(user, PERMISSIONS.COMPARISONS_NEW_PORTFOLIO);
  const hasClientAccountPermission = userHasPermissionEnabled(user, PERMISSIONS.COMPARISONS_CLIENT_ACCOUNT);
  const hasModelPortfolioPermission = userHasPermissionEnabled(user, PERMISSIONS.COMPARISONS_MODEL_PORTFOLIO);
  const hasLoadFactSetPortfolios = userHasPermissionEnabled(user, PERMISSIONS.COMPARISONS_LOAD_FACTSET_PORTFOLIOS);

  return (
    <Modal show={show} onHide={onClose} className="create-analysis-modal" dialogClassName="modal-dialog-centered" size={MODAL_SIZES.XL}>
      <Modal.Header>
        {/* Provisional fix. Pending migration to library modal. */}
        <Typography as={ALLOWED_HTML_TAGS.H2} color="primary" variant="headerXs">
          <FormattedMessage id="ComparisonHome.CreateAnalysisModal.Title" />
        </Typography>
        <CloseButton onClick={onClose} />
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage tagName="p" id="ComparisonHome.CreateAnalysisModal.Description" />
        <ComparisonActionCards
          hasClientAccountPermission={hasClientAccountPermission}
          hasModelPortfolioPermission={hasModelPortfolioPermission}
          hasNewPortfolioPermission={hasNewPortfolioPermission}
          hasLoadFactSetPortfolios={hasLoadFactSetPortfolios}
          onClickClient={onClickClient}
          onClickModel={onClickModel}
          onClickPortfolio={onClickPortfolio}
          onClickLoadFactSetPortfolios={onClickFactsetPortfolios}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CreateAnalysisModal;
